module.exports = __webpack_public_path__ + "img/brand-icon6.5ecef59f.jpg";